$(document).ready(function() {
  if ($('#main-map').length) {
    MainMap.init();
  }

  if ($('#voies-lyonnaises-map').length) {
    VoiesLyonnaisesMap.init();
  }
});
